import { BaseResponseDto, CountryListDto, GetCountriesFilter } from "@aoe/client";
import { createActionGroup, emptyProps, props } from "@ngrx/store";
import { CountryResponse } from "../../interfaces/CountryResponse.interface";

export const countryActions = createActionGroup({
    source: 'Country',
    events: {
        ['[Country - API] Load country']: props<{ payload?: GetCountriesFilter }>(),
        ['[Country - API] Load success']: props<CountryResponse>(),
        ['[Country - API] Load failed']: props<BaseResponseDto<CountryListDto>>(),
        // ['[Country - API] Create country']: props<{ payload: 
        // ['[Country - API] Country created']: props<CountryResponse>(),
        // ['[Country - API] Country created failed']: props<CreateCoun >(),
        // ['[Country - API] Update country']: props<{ payload: 
        // ['[Country - API] Country updated']: props<CountryResponse>(),
        // ['[Country - API] Country updated failed']: emptyProps(),
        // ['[Country - API] Delete country']: props<{ payload: 
        [`[Country - API] Reset country`]: emptyProps()

    }
})